module.exports = __webpack_public_path__ + "static/media/yellow-note-text.a5bb00d7.svg";